<template>
  <div class="mobile-wrapper bg-white">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" @click="goBack"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4 justify-content-center">
      <div class="col-lg-9 bg-white py-2">
        <div class="pt-3">
          <div class="row">
            <div class="col-sm-12 text-center">
              <h1 class="fw-normal">{{displayModel.orderState}}</h1>
              <div class="alert alert-primary" role="alert" v-if="createUserForGuest">
                <span>{{ $t('message.emailConfirmation') }}.</span>
              </div>
            </div>
          </div>
          <div class="row" v-show="false">
            <div class="col-sm-12 text-center dtime color-gray">
              <i class="material-icons color-light-gray">query_builder</i>
              <span>
                {{ displayModel.orderMode }} in approximately
                {{ minutes }}mins
              </span>
            </div>
          </div>
          <div class="row" v-if="displayModel.status > -1">
            <div class="col-sm-12 d-flex justify-content-center multi-steps-wrapper">
              <ul class="list-unstyled cstepper">
                <li>
                  <div
                    class="node gray"
                    :class="{ activated: displayModel.status > 0 && displayModel.status <= 3 }"
                  ></div>
                  <p>{{ $t('message.orderSubmitted') }}</p>
                </li>
                <li>
                  <div
                    class="divider"
                    :class="{
                      black: displayModel.status > 0 && displayModel.status < 3,
                      gray: !(displayModel.status > 0 && displayModel.status < 3)
                    }"
                  ></div>
                </li>
                <li>
                  <div
                    class="node gray"
                    :class="{ activated: displayModel.status > 0 && displayModel.status < 3 }"
                  ></div>
                  <p>{{ $t('message.beingPrepared') }}</p>
                </li>
                <li>
                  <div
                    class="divider"
                    :class="{
                      black: displayModel.status === 2,
                      gray: displayModel.status !== 2
                    }"
                  ></div>
                </li>
                <li>
                  <div class="node gray" :class="{ activated: displayModel.status === 2 }"></div>
                  <p>{{ $t('message.ready') }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-center d-flex justify-content-center">
              <div v-if="displayModel.status  === -1" class="text-danger">
                <div>{{ $t('message.yourOrderHasBeenRejected') }} ({{trackingOrder.OnlineOrderStatusDescription}})</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 text-center d-flex justify-content-center">
              <div v-if="store.Location" class="storeInfo">
                <router-link class="text-primary pr-2" to="#">Pick up from</router-link>
                <div>{{ store.Name }}</div>
                <div>{{ store.Location.Address }}</div>
                <div>{{ store.Location.Suburb }} {{ store.Location.State }}</div>
              </div>
            </div>
          </div>
          <div class="row order-history-div">
            <div class="col-sm-12 text-center">
              <button
                v-show="user"
                type="button"
                class="btn btn-primery pr-2 btn-with-margins"
                @click="viewHistory"
              >{{ $t('message.viewMyOrderHistory') }}</button>
              <br />
              <button
                type="button"
                class="btn btn-info pr-2 btn-with-margins"
                @click="continueShopping"
              >{{ $t('message.continueOrdering') }}</button>
              <poweredby />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../../sharedscripts/shop/Checkout/CompleteOrder.js";
import poweredby from "../../shared/poweredby";
export default {
  components: {
    poweredby
  },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    orderid: {
      type: String,
      default: ""
    },
    userid: {
      type: String,
      default: ""
    },
    createUserForGuest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      store: {},
      trackingOrder: {},
      minutes: 0,
      displayModel: {
        orderMode: "Pickup",
        orderState: "Order Sent!",
        status: -1
      }
    };
  },
  computed: {
    ...mapGetters(["user"]),
    ...shared.computed
  },
  watch: {
    ...shared.watch
  },
  beforeDestroy() {
    this.beforeDestroyComponent();
  },
  created() {
    this.createdComponent();
  },
  methods: {
    ...shared.methods,
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.storeid }
      });
    }
  }
};
</script>
